import React, { CSSProperties, useState } from "react";
import { inject, observer } from "mobx-react";
import { Checkbox as CheckboxAntd, Form } from "antd";
import { IAppStore } from "stores/Interfaces";
import { FieldConfig } from "components/common/forms/Interfaces";

interface Props {
  defaultChecked?: boolean;
  store?: IAppStore;
  entityId?: unknown;
  name: string;
  disabled?: boolean;
  config?: FieldConfig;
  form?: any;
}

const Checkbox: React.FC<Props> = ({
  store,
  defaultChecked,
  entityId,
  name,
  disabled,
  config,
  form,
  ...rest
}) => {
  const [checkboxValue, setCheckboxValue] = useState<boolean>(
    defaultChecked as boolean
  );

  const formStyles = {
    marginBottom: 0,
    height: "auto",
    marginTop: 0,
    top: "-5px",
    position: "static",
  } as CSSProperties;

  const onChange = (event: any) => {
    const { checked } = event.target;

    form.setFieldsValue({
      [name]: checked ? 1 : 0,
    });

    setCheckboxValue(checked);
  };

  return (
    <Form.Item
      name={name}
      label={config?.label}
      rules={config?.validationRules}
      labelCol={{ span: 24 }}
      style={formStyles}
      {...(config?.extra || {})}
      {...rest}
    >
      <CheckboxAntd
        defaultChecked={defaultChecked}
        key={name}
        disabled={disabled}
        onChange={onChange}
        checked={checkboxValue}
      />
    </Form.Item>
  );
};

export default inject("store")(observer(Checkbox));
